import * as XLSX from 'xlsx';

export const readExcelFile = async () => {
  try {
    const response = await fetch('/Landing Page Data/Warrantee Tab online & Arabic  names.xlsx');
    if (!response.ok) {
      throw new Error('Failed to fetch Excel file');
    }
    const arrayBuffer = await response.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
    
    if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
      throw new Error('No sheets found in Excel file');
    }
    
    // First sheet - Popup content
    const popupSheet = workbook.Sheets[workbook.SheetNames[0]];
    const popupData = XLSX.utils.sheet_to_json(popupSheet, { header: 1, defval: '' });
    
    // Second sheet - Product names in Arabic (if exists)
    let productsData = [];
    if (workbook.SheetNames.length > 1) {
      const productsSheet = workbook.Sheets[workbook.SheetNames[1]];
      productsData = XLSX.utils.sheet_to_json(productsSheet, { header: 1, defval: '' });
    }
    
    return {
      popupContent: popupData,
      productNames: productsData
    };
  } catch (error) {
    console.error('Error reading Excel file:', error);
    return {
      popupContent: [],
      productNames: []
    };
  }
};

